export default __webpack_public_path__ + "static/media/gitup.85f48842.svg";